import {NavLink as RouterLink, useMatch} from "react-router-dom";

import {styles} from "./SidebarSubItem.styles";
import {SidebarItem} from "../SidebarItem/SidebarItem";
import {SidebarItemContent} from "../SidebarItemContent/SidebarItemContent";

type SidebarSubItemProps = {
  disabled?: boolean;
  title: string;
  to: string;
  path: string;
};

export const SidebarSubItem: React.FC<SidebarSubItemProps> = ({disabled, title, to, path}) => {
  const match = useMatch(path);

  return (
    <SidebarItem disabled={disabled}>
      <RouterLink
        to={to}
        className={({isActive}) => `${styles.sidebarSubItemLink} ${isActive || match ? "link-active" : ""}`}
      >
        <SidebarItemContent text={title} className={styles.sidebarSubItemContent} />
      </RouterLink>
    </SidebarItem>
  );
};
